module.exports = __webpack_public_path__ + "img/logo2.c4de5f49.png";